import React from 'react'
import styles from './styles.module.scss'
import NextImage from 'next/image'

export type TabItemProps = {
  text: string
  subTitle: React.ReactNode
  description?: string
  img?: {
    url: string
    width: string | number
    height: string | number
  }
  icon?: React.ReactElement
  extraClass?: string
  classes?: string
}

function TabItem({
  text,
  subTitle,
  description,
  img,
  icon,
  extraClass = '',
  classes = ''
}: TabItemProps) {
  return (
    <section className={`${styles.lightboxContent__item} ${classes}`}>
      {img?.url && (
        <NextImage
          alt={text}
          src={img?.url}
          width={img?.width as number}
          height={img?.height as number}
        />
      )}
      {icon}
      <h5 className={`${styles.lightboxContent__subtitle} ${extraClass}`}>
        {subTitle}
      </h5>
      {description && (
        <p className={`${styles.lightboxContent__description} ${extraClass}`}>
          {description}
        </p>
      )}
    </section>
  )
}

export default TabItem
